module.exports = __webpack_public_path__ + "img/Weapon_201.02902ba8.png";